import React from "react";
import { useUserContext } from "context/UserContext";
import CreditsSP from "layouts/SP/credit";
import { normalizeRoleLevel } from "utils/roleUtils";

function Credits() {
  const { roleLevel } = useUserContext() || {};
  if (!normalizeRoleLevel(roleLevel)) {
    return <CreditsSP />;
  }
  return null;
}

export default Credits;
